import { FullscreenButton as FullscreenButton$1 } from "../../../../../ui/fullscreen-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/fullscreen-enter.js";
import ForwardRef$1 from "../../../../../icons/dist/react/minimal/fullscreen-exit.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-live-video/components/buttons/fullscreen-button.tsx
/** @jsxImportSource react */
function FullscreenButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(FullscreenButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-fullscreen-button", resolveClassName(className, state)),
		...props,
		children: [/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-fullscreen-button-enter-icon") }), /* @__PURE__ */ jsx(ForwardRef$1, { className: cn("media-button-icon", "media-fullscreen-button-exit-icon") })]
	});
}
//#endregion
export { FullscreenButton };

//# sourceMappingURL=fullscreen-button.js.map